  import { Component, OnInit } from '@angular/core';
import { CreateFormElementTypeService } from './services/create-form-element-type.service';
import { finalize } from 'rxjs';
import { CurrentUserDetails } from '@app/shared/models/employee.model';
import { SnackbarService } from '@app/core/services/snackbar.service';
import { OverlayService } from '@app/shared/components/overlay/overlay.service';
import { TranslateService } from '@ngx-translate/core';
import { EmployeeService } from '@app/core/services/employee.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-create-form-element-type',
  templateUrl: './create-form-element-type.component.html',
  styleUrls: ['./create-form-element-type.component.scss']
})
export class CreateFormElementTypeComponent {
  formId: string = "frm_utEr5m4XE9wqzh";
  formData: any;
  getFormData: boolean = false;
  formValid: boolean = false;
  formPristine: boolean;
  currentEmployeeDetails: CurrentUserDetails;

  constructor(
    private createFormElementTypeService: CreateFormElementTypeService,
    private snackbarService: SnackbarService,
    private overlayService: OverlayService,
    private translate: TranslateService,
    private employeeService: EmployeeService,
    private router: Router,
  ) {
    this.currentEmployeeDetails = this.employeeService.getFetchedCurrentUserDetails();
    
    if(this.currentEmployeeDetails.userType !== 'User'){
      this.router.navigate(['Homepage'])
    }
  }

  ngOnInit(): void {
  }

  formDataEmitted(formData) {
    this.save(formData);
  }

  formPristineEmitted(formPristine: boolean) {
    this.formPristine = formPristine;
  }

  formStatusUpdated(formValid) {
    this.formValid = formValid;
  }

  save(formData) {
    this.overlayService.show();

    this.createFormElementTypeService.createFormElementType(formData)
    .pipe(
      finalize(() => this.overlayService.hide())
    )
    .subscribe(
      (res) => {
        this.snackbarService.openSnackBar(`${this.translate.instant('SavedSuccessfully')}`, 'clear', 'success');
      }
    );
  }

}
